import { parseCommandResult } from '@/widgets/macros'

const TTL_MS = 90000
const cache = new Map() // nodeId -> { at, widgets }

export function invalidateQlcButtons(nodeId) {
  if (nodeId) cache.delete(String(nodeId))
  else cache.clear()
}

export function peekQlcButtons(nodeId) {
  const hit = cache.get(String(nodeId || ''))
  if (!hit) return null
  if (Date.now() - hit.at > TTL_MS) return null
  return hit.widgets
}

/**
 * Cached QLC button list. Status is polled separately — this is id/name/type only.
 * @param {Function} sendCommand vuex mission/sendCommand
 * @param {string} nodeId
 * @param {{ force?: boolean }} [opts]
 */
export async function getQlcButtons(sendCommand, nodeId, opts = {}) {
  const id = String(nodeId || '')
  if (!id) return []
  const force = !!opts.force
  if (!force) {
    const hit = cache.get(id)
    if (hit && Date.now() - hit.at < TTL_MS) {
      return hit.widgets
    }
  }
  const res = await sendCommand({
    node_id: id,
    adapter: 'qlc',
    action: 'listWidgets',
    payload: { buttonsOnly: true, refresh: force },
  })
  const data = parseCommandResult(res) || {}
  const widgets = Array.isArray(data.widgets) ? data.widgets : []
  cache.set(id, { at: Date.now(), widgets })
  return widgets
}
